import { useState } from "react";
import { useForm } from "react-hook-form";
import { Auth } from "aws-amplify";

import Button from "../../../common/components/controls/button/styled-button";
import { InfoText } from "../../../common/components/info_text";
import { Field } from "../../../common/components/controls/field";
import { FormStepCard } from "../../../common/components/form_steps";

import { ScreenProps } from "../dtos";

import { textChooser } from "../../../common/util/textChooser";
import { generateEncryptEmail, hasNumber, hasUpperCaseLetter } from "../../../common/helpers/utilities";

import { ForgotPassForm } from "./styled";

export const UpdatePasswordScreen = ({ stateScreen, dispatchScreen }: ScreenProps) => {
  const initialState = { pass: false, code: false, num: false, upper: false };

  const { register, handleSubmit } = useForm();

  const [errors, setErrors] = useState(initialState);
  const encryptedEmail = generateEncryptEmail(stateScreen.who);

  const handleSubmition = (data: any) => {
    // when password are not the same
    if (data.pass1 !== data.pass2) {
      setErrors({ ...initialState, pass: true });
      return;
    }
    // when password doesn´t have a number
    if (!hasNumber(data.pass1)) {
      setErrors({ ...initialState, num: true });
      return;
    }
    // when password doesn´t have a uppercase letter
    if (!hasUpperCaseLetter(data.pass1)) {
      setErrors({ ...initialState, upper: true });
      return;
    }

    Auth.forgotPasswordSubmit(stateScreen.who, data.code, data.pass1).then(() => {
      dispatchScreen({ ...stateScreen, currentScreen: 3 });
    }).catch(() => {
      setErrors({ ...initialState, code: true });
    });
  }

  const handleGoBackBtn = () => {
    dispatchScreen({
      ...stateScreen, currentScreen: 1
    });
  }

  return (
    <FormStepCard
      title={textChooser("txt13")}
      handleBackButton={handleGoBackBtn}
      showBackButton={true}
    >
      <ForgotPassForm onSubmit={handleSubmit(handleSubmition)}>
        <InfoText text={textChooser("txt40", [encryptedEmail])} type="plain" />
        <Field
          type="text"
          hasIcon={true}
          hasError={false}
          label={textChooser("txt34")}
          placeholder={"Ex: A4Fd5o"}
          testId={"code-recovery-field"}
          maxLength={8}
          minLength={6}
          hooks={{ ...register("code", { required: true }) }}
        />

        <InfoText
          text={textChooser("txt46")}
          type="danger"
          hidden={!errors.code}
        />

        <Field
          type="password"
          hasIcon={true}
          hasError={errors.pass}
          label={textChooser("txt41")}
          placeholder={textChooser("txt5")}
          testId={"pass1-recovery-field"}
          maxLength={35}
          minLength={6}
          hooks={{ ...register("pass1", { required: true }) }}
        />

        <InfoText
          text={textChooser("txt37")}
          type="danger"
          hidden={!errors.pass}
        />

        <Field
          type="password"
          hasIcon={true}
          hasError={errors.pass}
          label={textChooser("txt42")}
          placeholder={textChooser("txt5")}
          testId={"pass2-recovery-field"}
          maxLength={35}
          minLength={6}
          hooks={{ ...register("pass2", { required: true }) }}
        />

        <InfoText
          text={textChooser("txt37")}
          type="danger"
          hidden={!errors.pass}
        />

        <InfoText
          text={textChooser("txt44")}
          type="success"
          hidden={!errors.num}
        />

        <InfoText
          text={textChooser("txt45")}
          type="success"
          hidden={!errors.upper}
        />

        <Button type="submit">{textChooser("txt13")}</Button>
      </ForgotPassForm>
    </FormStepCard>
  )
}